import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { AddBoxRounded } from '@material-ui/icons';

interface Props {
  /**
   * Material UI Icon
   */
  icon?: React.ReactNode;
  onClick: (e: any) => void;
  tooltip?: string;
  hide?: boolean;
  'data-cy'?: string;
}

const CardListAction: React.FC<Props> = ({
  icon = <AddBoxRounded />,
  onClick,
  tooltip = '',
  hide = false,
  ...rest
}) => {
  return hide ? null : (
    <Tooltip title={tooltip}>
      <IconButton onClick={onClick} data-cy={rest['data-cy']} color='primary'>
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default CardListAction;
